export const CLOSE_MAIN_MENU = 'CLOSE_MAIN_MENU';
export const OPEN_MAIN_MENU = 'OPEN_MAIN_MENU';



// WEBPACK FOOTER //
// ./src/actions/mainMenu/types.js